import { PersonalInfoSubmitData } from "@app/features/payment/ui/ConfirmPurchaseWithPersonalInfoInputModal.tsx";
import { openConfirmPurchaseWithPersonalInfoModal } from "@features/payment/ui/OpenConfirmPurchaseWithPersonalInfoModal.tsx";
import {
	FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand,
	FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResult
} from "@fxid/openapi-client";
import { FxIdSdkAdapterForFxId, IframeType } from "@fxid/sdk";
import { IExportedFxIdSdkMethod } from "@fxid/sdk-core";

import OpenApiClient from "../../../../packages/fxid-openapi-client/src/OpenApiClient.ts";

export const handlePersonalInfoRequirements = async (
	fxIdInstance: IExportedFxIdSdkMethod,
	game: string,
	adapter: IframeType,
	createPaymentResult: FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResult,
	compact: boolean,
	mode: "horizontal" | "vertical"
) => {
	if (createPaymentResult.PersonalInfoRequirements != null) {
		try {
			fxIdInstance.DispatchDisableKeyboardInputCapture();
			const piData = await new Promise<PersonalInfoSubmitData>((resolve, reject) => {
				openConfirmPurchaseWithPersonalInfoModal({
					source: "modal",
					paymentResult: createPaymentResult,
					compact,
					mode,
					analyticsData: {
						game,
						adapter
					},
					onSubmit: (piData) => {
						resolve(piData);
					},
					onClose: () => {
						reject(new Error("Email input cancelled"));
					}
				});
			});

			// Use StoreApi's UpdateOrderPi to send data from piData
			// Only send if email actually changed
			const currentEmail = createPaymentResult.PersonalInfoRequirements?.EmailRequirement?.DefaultValue;
			const newEmail = piData.email || "";
			const emailChanged = !currentEmail || currentEmail.toLowerCase() !== newEmail.toLowerCase();

			if (emailChanged) {
				try {
					const updateOrderPICommand: FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand =
						{
							PublicOrderId: createPaymentResult.TransactionId,
							OrderPersonalInfo: {
								Email: newEmail,
								PhoneNumber: piData.phone || null,
								IsAutoConfirm: piData.autoConfirm === true
							}
						};

					await OpenApiClient.Store.fxIdWebFeaturesStoreUpdateOrderPISendSupportMessageEndpoint(
						updateOrderPICommand
					);

					log.info("Personal information updated successfully");
				} catch (error) {
					log.error(
						`Failed to update personal information for order ${createPaymentResult.TransactionId}:`,
						error
					);
					throw new Error(
						`Failed to update personal information for order ${createPaymentResult.TransactionId}: ` + error
					);
				}
			} else {
				log.info(`Email not changed (${newEmail}), skipping update-order-pi request`);
			}
		} finally {
			fxIdInstance.DispatchEnableKeyboardInputCapture();
		}
	}
};
